export default {
  playedPiecesTitle: '当前已演奏曲目:',
  loading: '加载中...',
  success: '成功',
  failed: '失败',
  emptyHistory: '暂无演奏记录',
  emptyPerformLog: '暂无演奏日志或视频',
  performVideoLabel: '演奏视频',
  liveStreamVideoLabel: '钢琴机器人实时视频',
  back: '返回',

  performMode: '演奏模式',
  voiceInput: '语音输入',
  stopPerform: '停止演奏',
  fetchSongs: '获取歌曲',
  startService: '启动服务',
  emptyHello: '你好！',
  emptySub: '请说出你想听的曲目名称',
  thinkingProcess: '思考过程 ：',
  planningLabel: '思考过程',
  songListTitle: '歌曲清单',
  closeSongList: '关闭歌曲清单',
  songListFetchError: '获取歌曲列表失败',
  noSongs: '暂无歌曲',
  loadMoreSongs: '加载更多歌曲',
  serviceStarted: '钢琴机器人服务已启动',
  playSongPrompt: '请弹奏 {name}',
  uplinkSpeedTitle: '5G-A 上行速率',
  uplinkLatencyTitle: '5G-A 时延',
  poweredBy: 'Powered by 晨昏线科技',

  planStep: {
    searchSong: '搜索歌曲',
    analyzeSong: '分析歌曲',
    parseHardware: '解析硬件参数',
    generateFingering: '大模型基于硬件参数生成指法',
    startPlaying: '开始演奏',
  },

  hardwareStepDesc:
    '左右臂：7自由度络石机械臂AR5、左右手：18自由度腱绳灵巧手TermiHand。\n经分析，机械臂存在移动时延0.3s以上，灵巧手小拇指可拓展按键一个。',
}
